import { render, staticRenderFns } from "./AstaBustaChiusa.vue?vue&type=template&id=221954ae&"
import script from "./AstaBustaChiusa.vue?vue&type=script&lang=js&"
export * from "./AstaBustaChiusa.vue?vue&type=script&lang=js&"
import style0 from "./AstaBustaChiusa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221954ae')) {
      api.createRecord('221954ae', component.options)
    } else {
      api.reload('221954ae', component.options)
    }
    module.hot.accept("./AstaBustaChiusa.vue?vue&type=template&id=221954ae&", function () {
      api.rerender('221954ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaBustaChiusa.vue"
export default component.exports